import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { type AIRateLimitResponse, getAIRateLimit } from "../api/connectAI";

export const aiRateLimitQueryKey = ["aiRateLimit"] as const;

export const useAIRateLimit = (): UseQueryResult<AIRateLimitResponse> => {
	return useQuery<AIRateLimitResponse>({
		queryKey: aiRateLimitQueryKey,
		queryFn: ({ signal }) => getAIRateLimit(signal),
	});
};
